module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "car-engine.acc5e126.svg";